import {
  SET_MARKET_PRICE,
  SET_LAST_PRICE,
  SET_BOD_PRICE,
  SET_BET,
} from "./types";

const initialState: any = {
  bet: 1,
};

const CoinPriceReducer = (state = initialState, { payload, type }: any) => {
  switch (type) {
    case SET_MARKET_PRICE: {
      const { market, price } = payload;
      return { ...state, [market]: price };
    }

    case SET_LAST_PRICE: {
      const { lastPrices = {} } = state;
      const { ts, market, price } = payload;

      return { ...state, lastPrices: { ...lastPrices, [market]: { ts, price } } };
    }

    case SET_BOD_PRICE: {
      const { type, market, price } = payload;
      const { bodPrices = {} } = state;

      bodPrices[type] = {
        ...(bodPrices[type] || {}),
        [market]: price,
      };

      return { ...state, bodPrices: { ...bodPrices } };
    }

    case SET_BET: {
      return {
        ...state,
        bet: payload,
      };
    }
    default:
      return state;
  }
};

export default CoinPriceReducer;
